// PersonaZone, French.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Persona': 'Persona',
  'synthesised from the held interactions, the mail and the dossier':
    'synthétisée à partir des points de contact retenus, des courriels et du dossier',
  'version {n} · {status} · every trait carries a verbatim quote':
    'version {n} · {status} · chaque trait porte une citation littérale',
  'Synthesise': 'Synthétiser',
  'Starting…': 'Démarrage…',
  'loading…': 'chargement…',
  'The persona could not be read: {error}': 'La persona n’a pas pu être lue : {error}',
  '{ref} started. It reads the record and files a proposal; nothing is written until you hold it.':
    '{ref} démarré. Le passage lit le dossier et dépose une proposition ; rien n’est écrit tant que vous ne la retenez pas.',
  '{ref} is running. When it finishes, its persona waits in Review.':
    '{ref} est en cours. À la fin, sa persona attend dans la revue.',
  'Could not start the run.': 'Le passage n’a pas pu démarrer.',
  'No persona yet. Synthesise reads the held interactions, the mail and the dossier and proposes traits — topics, style, decision role, objections, register, timing — each carrying at least one verbatim quote. A trait without a quote is dropped before the proposal is filed, and the proposal is held in Review like any other.':
    'Pas encore de persona. « Synthétiser » lit les points de contact retenus, les courriels et le dossier, et propose des traits — sujets, style, rôle décisionnel, objections, registre, rythme — chacun portant au moins une citation littérale. Un trait sans citation est écarté avant le dépôt, et la proposition se retient dans la revue comme toute autre.',
  'Hide quotes': 'Masquer les citations',
  '{n} quotes': '{n} citations',
  'no quote': 'aucune citation',
  'no source named': 'aucune source nommée',
  'filed by': 'déposée par',
  'Hold it in Review': 'La retenir dans la revue',

  // trait keys
  'Topics': 'Sujets',
  'Style': 'Style',
  'Decision role': 'Rôle décisionnel',
  'Objections': 'Objections',
  'Register': 'Registre',
  'Timing': 'Rythme',

  // evidence kinds
  'interaction': 'point de contact',
  'document': 'document',
  'snapshot': 'capture',
  'url': 'URL',
  'manual': 'manuel',
}, 'PersonaZone');
